import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import {
  ClickstreamProvider,
  ClickstreamScene
} from '@zenbusiness/application-commons-clickstream';
import { useEnv } from '@zenbusiness/application-commons-env';
import { useVisit } from '@zenbusiness/application-commons-visit';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';

export default function ClickstreamWrapper({ children, ...delegated }) {
  const { DEPLOY_ENV, RUDDERSTACK_API_KEY, RUDDERSTACK_URL } = useEnv('head-first'); // use MFE values

  const { accountUuid, obo } = useAuthentication();
  const { businessEntityUuid } = useBusinessEntity();
  const { visitUuid } = useVisit();
  const { sizes } = useBreakpoints();

  const formFactorMobile = sizes.isTablet ? 'tablet' : 'phone';
  const systemProperties = {
    accountUuid,
    businessEntityUuid,
    channel: 'web',
    formFactor: sizes.isDesktop ? 'desktop' : formFactorMobile,
    trackingConsent: 'all',
    visitUuid
  };

  return (
    <ClickstreamProvider
      deployEnv={DEPLOY_ENV}
      noop={!!obo}
      rudderstackApiKey={RUDDERSTACK_API_KEY}
      rudderstackApiUrl={RUDDERSTACK_URL}
      {...delegated}
      systemProperties={systemProperties}
    >
      <ClickstreamScene
        appOrigin="banking-ui"
        appSection="banking"
        experienceOrigin="dashboard"
      >
        {children}
      </ClickstreamScene>
    </ClickstreamProvider>
  );
}
